import deepFreeze from "deep-freeze";

const lineProcess = element => {
  element = deepFreeze(element);

  let line = { ...element };

  return line;
};

export default lineProcess;
